import floor from "lodash/fp/floor";
import constants from "../../core/constants";

class Controller {
  constructor() {
    "ngInject";
  }

  $onInit() {
    this.percentage = (this.capacity.count / this.capacity.maximum) * 100;
    this.isComplete = this.percentage === constants.utilizationComplete;
    this.roundedPercentage = floor(this.percentage);
    this.status =
      this.percentage <= constants.utilizationWarn
        ? "danger"
        : this.percentage >= constants.utilizationWarn &&
          this.percentage <= constants.utilizationsuccess
        ? "warn"
        : "success";
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/utilizationBar/utilizationBar.controller.js